/**
 * @export 通知类型
 * @enum
 */
export enum EnumMessageType {
  sendLcicTitle = 'sendLcicTitle',
}
